import * as types from '../types/catalogTypes';

const initialState = {
  items: [],
  counts: null,
  source: '',
  loading: false,
  error: null,
};

export default function catalogReducer(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_CATALOG_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        ...(action.payload?.clear ? { items: [] } : {}),
      };
    case types.FETCH_CATALOG_SUCCESS:
      return {
        ...state,
        loading: false,
        items: action.payload.items || [],
        source: action.payload.source || '',
        counts: action.payload.counts != null ? action.payload.counts : state.counts,
      };
    case types.FETCH_CATALOG_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
}
